/* =========================
   OPTIMIZED GLOBAL.JS
   Safe Performance Version
   ========================= */

/* ---------- Helpers ---------- */
if (window.haloInitialized) {
    console.warn('Halo already initialized');
} else {
    window.haloInitialized = true;
}

function checkViewport(viewport) {
    return window.innerWidth < viewport;
}

function resetForm(form) {
    if (!form) return;

    const fields = form.querySelectorAll('.form-field');
    if (fields.length) {
        fields.forEach((element) => {
            element.classList.remove('form-field--success', 'form-field--error');
        });
    }

    form.querySelectorAll('input[type=email], input[type=text], textarea').forEach((element) => {
        element.value = '';
    });
}

/* ---------- Cookies ---------- */

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 86400000));

    document.cookie =
        `${cname}=${cvalue};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

function getCookie(cname) {
    const name = `${cname}=`;

    return document.cookie
        .split(';')
        .map(c => c.trim())
        .find(c => c.indexOf(name) === 0)
        ?.substring(name.length) || '';
}

function deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
}

/* ---------- Focus Trap ---------- */

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    const elements = getFocusableElements(container);

    if (!elements.length) return;

    const first = elements[0];
    const last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        ) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = () => {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = (event) => {
        if (event.code.toUpperCase() !== 'TAB') return;

        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) {
        elementToFocus.focus();
    }
}

/* ---------- Media ---------- */

function pauseAllMedia() {

    document.querySelectorAll('.js-youtube').forEach((video) => {
        if (video.contentWindow) {
            video.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                '*'
            );
        }
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        if (video.contentWindow) {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
        }
    });

    document.querySelectorAll('video').forEach((video) => {
        try {
            video.pause();
        } catch (e) {}
    });

    document.querySelectorAll('product-model').forEach((model) => {
        try {
            model.modelViewerUI?.pause();
        } catch (e) {}
    });
}

/* ---------- Utilities ---------- */

function debounce(fn, wait = 300) {
    let t;

    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = (form) => {
    const obj = {};
    const formData = new FormData(form);

    for (const key of formData.keys()) {

        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

        if (regex.test(key)) {

            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);

        } else {

            obj[key] = formData.get(key);

        }
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
        }
    };
}

function extractContent(string) {
    const div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText || '';
}

/* =========================
   Shopify Common JS
   ========================= */

window.Shopify = window.Shopify || {};

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function(selector, value) {

    if (!selector) return;

    for (let i = 0, count = selector.options.length; i < count; i++) {

        const option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {

    if (!target) return;

    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options = {}) {

    const method = options.method || 'post';
    const params = options.parameters || {};

    const form = document.createElement('form');

    form.method = method;
    form.action = path;

    Object.keys(params).forEach((key) => {

        const hiddenField = document.createElement('input');

        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];

        form.appendChild(hiddenField);
    });

    document.body.appendChild(form);

    form.submit();

    document.body.removeChild(form);
};

/* ---------- Country Province Selector ---------- */

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {

    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);

    this.provinceContainer =
        document.getElementById(options.hideElement || province_domid);

    if (!this.countryEl || !this.provinceEl) return;

    Shopify.addListener(
        this.countryEl,
        'change',
        Shopify.bind(this.countryHandler, this)
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {

    initCountry: function() {

        const value = this.countryEl.getAttribute('data-default');

        Shopify.setSelectorByValue(this.countryEl, value);

        this.countryHandler();
    },

    initProvince: function() {

        const value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function() {

        const opt = this.countryEl.options[this.countryEl.selectedIndex];

        const raw = opt.getAttribute('data-provinces');

        const provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (!provinces || provinces.length === 0) {

            this.provinceContainer.style.display = 'none';

        } else {

            for (let i = 0; i < provinces.length; i++) {

                const option = document.createElement('option');

                option.value = provinces[i][0];
                option.innerHTML = provinces[i][1];

                this.provinceEl.appendChild(option);
            }

            this.provinceContainer.style.display = '';
        }
    },

    clearOptions: function(selector) {

        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {

        values.forEach((value) => {

            const option = document.createElement('option');

            option.value = value;
            option.innerHTML = value;

            selector.appendChild(option);
        });
    }
};

/* ---------- Money Formatter ---------- */

Shopify.formatMoney = function(cents, format) {

    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }

    let value = '';

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    const formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {

        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');

        const dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );

        const cents = parts[1] ? decimal + parts[1] : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {

        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;

        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

/* =========================
   CART FUNCTIONS
   ========================= */

Shopify.getCart = function(callback) {

    fetch(`${window.routes.cart}.js`)
        .then((response) => response.json())
        .then((cart) => {

            if (typeof callback === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        })
        .catch(console.error);
};

Shopify.onCartUpdate = function(cart) {
    console.log('Cart updated:', cart);
};

Shopify.changeItem = function(line, quantity, callback) {

    fetch(`${window.routes.cart}/change.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `quantity=${quantity}&id=${line}`
    })
    .then((response) => response.json())
    .then((cart) => {

        if (typeof callback === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    })
    .catch((error) => {
        Shopify.onError(error);
    });
};

Shopify.removeItem = function(line, callback) {

    Shopify.changeItem(line, 0, callback);
};

Shopify.addItem = function(variant_id, quantity = 1, callback) {

    fetch(`${window.routes.cart}/add.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `quantity=${quantity}&id=${variant_id}`
    })
    .then((response) => response.json())
    .then((line_item) => {

        if (typeof callback === 'function') {

            setCookie('added-item', line_item.key, 1);

            callback(line_item);

        } else {

            Shopify.onItemAdded(line_item);
        }
    })
    .catch((error) => {
        Shopify.onError(error);
    });
};

Shopify.onItemAdded = function(line_item) {
    console.log(`${line_item.title} added to cart`);
};

Shopify.onError = function(error) {

    console.error('Shopify Error:', error);

    if (error?.description) {
        alert(error.description);
    }
};